import { EnrichmentRequest, EnrichmentResponse } from "./types";
import { fetchEnrichmentData } from "./graphqlClient";
import { fetchMockEnrichmentData } from "./mockData";

const USE_MOCK = process.env.MOCK_API !== "false";

/**
 * Fetches article enrichment data.
 * Delegates to the mock service or real GraphQL API based on configuration.
 *
 * @param request - The enrichment request.
 * @param accessToken - Bearer token for API authentication.
 * @param signal - Optional AbortSignal for cancellation support.
 */
export async function getEnrichmentData(
  request: EnrichmentRequest,
  accessToken: string,
  signal?: AbortSignal
): Promise<EnrichmentResponse> {
  if (USE_MOCK) {
    return fetchMockEnrichmentData(request, signal);
  }
  return fetchEnrichmentData(request, accessToken, signal);
}
